// Route prefetching for faster navigation
// These functions preload route chunks when user hovers over menu items

export const prefetchCustomFurnitureRoutes = () => {
  import("@/pages/CustomFurnitureMainPage");
  import("@/pages/CustomFurniturePage");
};

export const prefetchBlindsCurtainsRoutes = () => {
  import("@/pages/BlindsCurtainsMainPage");
  import("@/pages/BlindsMainPage");
  import("@/pages/CurtainsMainPage");
  import("@/pages/BlindsCurtainsPage");
};

export const prefetchUpholsteryRoutes = () => {
  import("@/pages/UpholsteryMainPage");
  import("@/pages/UpholsteryPage");
  import("@/pages/UpholsteryServicePage");
};

export const prefetchProjectsRoute = () => {
  import("@/pages/ProjectsPage");
};

export const prefetchContactRoute = () => {
  import("@/pages/ContactPage");
};
